import createStore from "@Stores/base-factories"
import hookSiteSelectedFactory from "@Stores/base-factories/store-site-selection"

const { Provider, useStore } = createStore()
  .extend(hookSiteSelectedFactory('siteId'))
  .extendHookCollectionFactory('cms/route')
  .extendHookCollectionsFactory('cms/routes')
  .factory()

export {
  Provider as RouteProvider,
  useStore as useRouteStore,
}
